import { createVNode as l, mergeProps as i } from "vue";
import m from "../node_modules/@pf-ui/pf-icon-svg/es/asn/PrevFilled.js";
import s from "../components/PfIcon.js";
const r = (e, t) => {
  const o = {
    ...e,
    ...t.attrs
  };
  return l(s, i(o, {
    icon: m
  }), null);
};
r.displayName = "PrevFilled";
r.inheritAttrs = !1;
export {
  r as default
};
